// 所有数据会进入assets/data/pageData进行过滤
// 泰语 ภาษาไทย Thai

// 顶部nav
const topNavData = {
  signUp: "สมัคร",
  logIn: "ล็อกอิน",
  application: "แบบฟอร์มใบสมัคร",
  home: "หน้าแรก",
  back: "ย้อนกลับ",
  profile: "ดูโปรไฟล์",
  contact: "ติดต่อเรา",
  logOut: "ล็อกเอาต์"
};

// 底部版权
const footerData = {
  service: "ข้อตกลงการให้บริการ",
  policy: "นโยบายความเป็นส่วนตัว",
  footerText: "Creator Zone คือแพลตฟอร์มทางการสำหรับคอนเทนต์ครีเอเตอร์โดย Lilith & Farlight Games",
};

// 首页文案
const homeData = {
};


// 注册页-选择地区
const signUpLanguageData = {
  title: "การเดินทางของท่านเริ่มต้นที่นี่",
  desc: "ท่านสร้างคอนเทนต์ในภาษาใด"
};

// 注册页
const signData = {
  title: "การเดินทางของท่านเริ่มต้นที่นี่",
  title2: "สมัคร",
  desc1: "เพื่อเป็นสมาชิกของ Creator Zone ",
  desc2: "โปรดตรวจสอบข้อกำหนดต่อไปนี้",
  signRule1_1: "เคารพแนว",
  signRule1_link: "ทางปฏิบัติชุมชน",
  signRule1_2: "ของเราและเป็นมิตรกับครีเอเตอร์และผู้จัดการชุมชนคนอื่นๆ",
  signRule2: "มีอายุอย่างน้อย 18 ปี",
  signOtherText1: "*ถ้าท่านไม่ผ่านข้อกำหนดด้านบน",
  signOtherText2: "โปรดส่งใบสมัครของท่านที่",
  signOtherLink: "นี่",
  signPlace1: "ใส่อีเมลของท่าน",
  signPlace2: "ตั้งชื่อผู้ใช้",
  signPlace3: "ตั้งรหัสผ่าน",
  signNeed1: "รหัสผ่านของท่านต้องมี:",
  signNeed2: "อักขระ 8 ถึง 20 ตัว",
  signNeed3: "ประกอบด้วยตัวอักษร ตัวเลข และอักขระพิเศษ",
  signNeed4_1: "ท่านได้อ่านข้",
  signNeed4_2: "อตกลงการให้บริการ",
  signNeed4_3: "และ",
  signNeed4_4: "นโยบายความเป็นส่",
  signNeed4_5: "วนตัวของ Creator Zone",
  accept: "ยอมรับ",
  next: "ถัดไป",
  send: "ส่งรหัส",
  codeTip: "ใส่รหัสตัวเลข 6 หลัก",
  accountTip1: "มีบัญชีอยู่แล้ว?",
  accountTip2: "ลงชื่อเข้าใช้",
};

// 个人信息页
const informationData = {
  title1: "แก้ไขข้อมูลบัญชี",
  accountTitle: "ข้อมูลบัญชี",
  mediaTitle: "โซเชียลมีเดีย",
  gameTitle: "เกม",
  birthdayTitle: "วันเกิด",
  realNameTitle: "ชื่อจริง",
  countryTitle: "ประเทศหรือภูมิภาค",
  languageTitle: "ภาษา",
  discordTitle: "Discord ID ของท่าน",
  discordDesc: "สำหรับให้เราติดต่อและสื่อสารกับท่าน",
};

// 欢迎/引导页
const guideData = {
  welcomeTitle: ["ยินดีต้อนรับสู่ Creator Zone!", " "],
  commRuleTitle: "กฎชุมชน",
  commRuleDesc: [
    "1. เคารพ",
    "เราต้องการสร้างสภาพแวดล้อมที่ให้การต้อนรับสำหรับทุกคน เสรีภาพในการแสดงออกคือสิ่งมีคุณค่าอย่างสูง แต่ภาษาก้าวร้าวหรือพฤติกรรมร้ายทางอ้อมสามารถนำไปสู่คำเตือนไปจนถึงการแบนจาก Creator Zone ในท้ายที่สุดได้",
    "2. การเลือกปฏิบัติ",
    "ไม่อนุญาตให้มีการกลั่นแกล้งหรือพฤติกรรมการเลือกปฏิบัติใดๆ ความคิดเห็นที่เป็นการด้อยค่าเกี่ยวกับเผ่าพันธุ์ ศาสนา วัฒนธรรม ความหลากหลายทางเพศ เพศสภาพหรืออัตลักษณ์ จะไม่ได้รับการยินยอมให้เกิดขึ้น และอาจเป็นผลให้ถูกแบนจาก Creator Zone",
    "3. การขายบัญชี",
    "การขายบัญชี บริการการแลกเปลี่ยนหรือส่งเสริม (ชำระเงิน) เป็นสิ่งต้องห้าม ครีเอเตอร์คนใดก็ตามที่เกี่ยวข้องกับกิจกรรมประเภทเหล่านี้อาจเป็นผลให้ถูกแบนจาก Creator Zone",
    "4. เนื้อหาลามกอนาจารหรือรบกวนจิตใจ",
    "การแจกจ่ายเนื้อหาลามกอนาจารหรือรบกวนจิตใจอาจเป็นผลให้ถูกแบนจาก Creator Zone",
    "5. การคัดลอกผลงาน",
    "คอนเทนต์ที่ถูกสร้างทั้งหมดควรเป็นผลงานต้นฉบับ การคัดลอกผลงานอาจส่งผลให้ถูกแบนจาก Creator Zone",
    "6. คำขาด",
    "เพียงเพราะไม่ได้มีกฎเขียนไว้ก็ไม่ได้หมายความว่าเราจะยอมให้มันเกิดขึ้นกับครีเอเตอร์ของเรา ทาง Lilith Games และ Farlight Games ขอสงวนสิทธิ์ในการตีความสุดท้ายของกฎเหล่านี้",
  ],
  agreeBtn: "ข้าพเจ้ายอมรับ",
  commRuleTip: "โปรดอ่านกฎชุมชนให้แล้วเสร็จ",
  nonRuleTitle: "ข้อตกลงไม่เปิดเผยข้อมูล",
  nonRuleTitle2: "นโยบายความเป็นส่วนตัว",
  nonRuleDescSub: [
    "1. แอสเซ็ตงานศิลป์ทั้งหมด ตัวอย่างแพตช์ และแอสเซ็ตอื่นๆ ที่เราจัดหาให้ผ่านทางแพลตฟอร์มจะถูกพิจารณาว่าเป็นความลับจนกว่าจะเปิดอย่างเป็นทางการ การปล่อยข้อมูลรั่วไหลหรือแสดงเนื้อหาใดๆ โดยไม่ได้รับอนุญาตจากพนักงานทางการจะไม่ได้รับการยินยอมให้เกิดขึ้นไม่ว่าจะกรณีใดก็ตาม",
    "2. การแชร์ข้อมูลอันเป็นความลับใดๆ หรือเนื้อหาของแพลตฟอร์มนี้ถือเป็นสิ่งต้องห้าม",
    "&nbsp;",
    "การรักษาความลับ",
  ],
  nonRuleDesc: [
    "1.1 คอนเทนต์ครีเอเตอร์รับทราบว่าความสัมพันธ์ของคอนเทนต์ครีเอเตอร์กับผู้รับบริการถือเป็นความไว้วางใจและความเชื่อมั่นอย่างสูง และในการให้บริการของคอนเทนต์ครีเอเตอร์แก่ผู้รับบริการ คอนเทนต์ครีเอเตอร์จะสามารถเข้าถึงและติดต่อกับข้อมูลบางอย่างได้ (\"ข้อมูลอันเป็นความลับ\") คอนเทนต์ครีเอเตอร์จะไม่เปิดเผยข้อมูลอันเป็นความลับใดๆ แก่บุคคลหรือนิติบุคคลอื่นใดนอกเหนือจากพนักงานของผู้รับบริการ หรือใช้ข้อมูลเดียวกันนี้เพื่อวัตถุประสงค์ใดๆ (นอกเหนือจากสมรรถภาพของบริการ) โดยไม่ได้รับอนุมัติเป็นลายลักษณ์อักษรจากพนักงานของผู้รับบริการ ทั้งในระหว่างหรือหลังการยุติ เว้นแต่และจนกว่าข้อมูลอันเป็นความลับดังกล่าวจะกลายเป็นความรู้สาธารณะโดยปราศจากความผิดโดยคอนเทนต์ครีเอเตอร์",
    "1.2 จุดประสงค์ของข้อตกลงนี้ ข้อมูลอันเป็นความลับจะหมายถึง ภาพประกอบและไม่จำกัดแค่ข้อมูลทั้งหมด ไม่ว่าจะเป็นลายลักษณ์อักษรหรือไม่ ไม่ว่าจะสามารถจดสิทธิบัตรได้หรือไม่และมีลิขสิทธิ์หรือไม่ก็ตาม ในลักษณะส่วนตัว ปิดบัง หรือเป็นความลับ ที่เป็นเจ้าของ ที่ครอบครองหรือใช้โดยผู้รับบริการ เกี่ยวข้องกับธุรกิจของผู้รับบริการ ความสัมพันธ์ทางธุรกิจหรือทางการเงิน รวมถึงแต่ไม่จำกัดเพียงการคิดค้น สูตร ข้อมูลผู้ขาย ข้อมูลลูกค้า เครื่องมือ อุปกรณ์ ความลับทางการค้า กระบวนการ การวิจัย รายงาน ข้อมูลทางเทคนิคหรือการวิจัย ข้อมูลทางคลินิก ความรู้ความชำนาญ โปรแกรมคอมพิวเตอร์ ซอฟต์แวร์ เอกสารซอฟต์แวร์ การออกแบบฮาร์ดแวร์ เทคโนโลยี ผลิตภัณฑ์ กระบวนการ วิธีการ เทคนิค สูตร สารประกอบ โครงการ การพัฒนา แผนการตลาดหรือธุรกิจ การคาดการณ์ งบการเงินที่ไม่ได้เผยแพร่ งบประมาณ ใบอนุญาต ราคา ต้นทุน ลูกค้า ผู้จัดหาหรือข้อมูลส่วนบุคคลหรือรายชื่อพนักงานที่สื่อสารถึง ได้เรียนรู้ พัฒนาหรือได้มาโดยคอนเทนต์ครีเอเตอร์ในแนวทางของบริการของคอนเทนต์ครีเอเตอร์ในฐานะคอนเทนต์ครีเอเตอร์ให้กับผู้รับบริการ",
    "1.3 สัญญาผูกมัดของคอนเทนต์ครีเอเตอร์ภายใต้หมวดที่ 6 นี้จะไม่นำไปใช้กับข้อมูลใดๆ ที่ (i) เป็นหรือเป็นที่รู้จักของสาธารณชนทั่วไปภายใต้สถานการณ์ที่ไม่เกี่ยวข้องกับการผิดสัญญาโดยคอนเทนต์ครีเตอร์หรือบุคคลอื่นๆ ของข้อกำหนดของหมวดที่ 6 นี้ (ii) ได้รับการเปิดเผยโดยทั่วไปแก่บุคคลที่สามโดยผู้รับบริการโดยไม่มีข้อจำกัดต่อบุคคลที่สามดังกล่าว หรือ (iii) ได้รับการอนุมัติให้ปล่อยโดยการอนุญาตเป็นลายลักษณ์อักษรจากเจ้าหน้าที่ของผู้รับบริการ",
    "1.4 คอนเทนต์ครีเอเตอร์ยอมรับว่าไฟล์ เอกสาร จดหมาย บันทึกเหตุการณ์ รายงาน บันทึก ภาพร่างข้อมูล ภาพวาด แบบจำลอง สมุดบันทึกสำหรับห้องปฏิบัติการ รายการโปรแกรม อุปกรณ์คอมพิวเตอร์ โปรแกรมคอมพิวเตอร์หรือเนื้อหาที่เป็นลายลักษณ์อักษร ภาพถ่าย หรือที่จับต้องได้อื่นๆ ที่ประกอบด้วยข้อมูลอันเป็นความลับ ไม่ว่าจะสร้างโดยคอนเทนต์ครีเอเตอร์หรือผู้อื่น ซึ่งจะอยู่ในการดูแลหรือครอบครองของคอนเทนต์ครีเอเตอร์ จะเป็นและเป็นทรัพย์สินเฉพาะของผู้รับบริการที่คอนเทนต์ครีเอเตอร์ใช้งานเฉพาะในสมรรถภาพของหน้าที่ของคอนเทนต์ครีเอเตอร์สำหรับผู้รับบริการเท่านั้นและจะไม่ถูกคัดลอกหรือถูกลบออกจากสถานที่ของผู้รับบริการ ยกเว้นเพื่อการแสวงหาธุรกิจของผู้รับบริการ เนื้อหาหรือสำเนาดังกล่าวทั้งหมดและทรัพย์สินที่จับต้องได้ของผู้รับบริการที่อยู่ในความดูแลหรือครอบครองของคอนเทนต์ครีเอเตอร์จะต้องส่งมอบให้กับผู้รับบริการ เมื่อ (i) คำขอจากผู้รับบริการก่อนหน้านี้ หรือ (ii) การยุติข้อตกลงนี้ หลังจากการส่งมอบดังกล่าว คอนเทนต์ครีเอเตอร์จะไม่เก็บเนื้อหาหรือสำเนาของเนื้อหาดังกล่าวหรือทรัพย์สินที่จับต้องได้ดังกล่าว",
    "1.5 คอนเทนต์ครีเอเตอร์ยอมรับว่าคอนเทนต์ครีเอเตอร์มีสัญญาผูกมัดที่จะไม่เปิดเผยหรือใช้ข้อมูลและเนื้อหาประเภทที่กำหนดไว้ในย่อหน้า (2) และ (4) ข้างต้น และคอนเทนต์ครีเอเตอร์มีสัญญาผูกมัดที่จะส่งคืนข้อมูลและทรัพย์สินที่จับต้องได้ที่กำหนดไว้ในย่อหน้า (4) ข้างต้นโดยครอบคลุมถึงประเภทของข้อมูล เนื้อหา และทรัพย์สินที่จับต้องได้ของลูกค้าของผู้รับบริการหรือผู้จัดหาไปยังผู้รับบริการหรือบุคคลที่สามอื่นๆ ที่อาจเปิดเผยหรือมอบหมายแบบเดียวกันนี้แก่ผู้รับบริการหรือคอนเทนต์ครีเอเตอร์",
    "1.6 คอนเทนต์ครีเอเตอร์รับทราบว่าบางครั้งผู้รับบริการอาจมีข้อตกลงกับบุคคลอื่นหรือกับรัฐบาลหรือหน่วยงานซึ่งกำหนดสัญญาผูกมัดหรือข้อจำกัดให้กับผู้รับบริการเกี่ยวกับการคิดค้นที่เกิดขึ้นระหว่างการทำงานภายใต้ข้อตกลงดังกล่าวหรือเกี่ยวกับลักษณะที่เป็นความลับของงานดังกล่าว คอนเทนต์ครีเอเตอร์ยอมรับที่จะผูกพันตามสัญญาผูกมัดและข้อจำกัดทั้งหมดที่คอนเทนต์ครีเอเตอร์ทราบ และดำเนินการทั้งหมดที่จำเป็นเพื่อปลดสัญญาผูกมัดของผู้รับบริการภายใต้ข้อตกลงดังกล่าว"
  ],
  nonSignText: "ข้าพเจ้าได้อ่านและยอมรับข้อตกลงไม่เปิดเผยข้อมูล",
  configBtn: "ยืนยัน",
  completeTitle: "เล่นโหมดฝึกฝนให้เสร็จ",
  finishTip: [
    "ขอแสดงความยินดีที่เล่นโหมดฝึกฝนเสร็จสิ้น!",
    "ยินดีต้อนรับสู่ Creator Zone!"
  ],
  guideTask: {
    "1": "เป็นสมาชิกของ Creator Zone",
    "2": "ล็อกอินให้เสร็จสิ้น",
    "3": "ประกาศครีเอเตอร์",
    "4": "ข้อตกลงไม่เปิดเผยข้อมูล",
    "5": "กรอกข้อมูลส่วนตัว",
    "6": "ผูกบัญชีโซเชียลมีเดีย",
    "7": "คำอธิบายระดับของครีเอเตอร์ ",
    "8": "วิดีโอต้อนรับ",
    "9": "เข้าร่วมช่อง Creator Discord",
  }
};

// 申请表单页
const applicationData = {
  applicationTitle: "โปรดกรอกแบบฟอร์มใบสมัคร",
  welcome: "ยินดีต้อนรับ",
  applicationDesc: [
    "โปรดกรอกแบบฟอร์มใบสมัครด้วยข้อมูลที่เป็นจริง",
    "ท่านจะได้รับสิทธิ์เข้าถึง Creator Zone ของเราหลังจากใบสมัครของท่านได้รับการอนุมัติ!"
  ],
  mediaModeTitle: "1. เลือกแพลตฟอร์มโซเชียลมีเดียของท่าน",
  mediaModeDesc: "โปรดผูกบัญชีโซเชียลมีเดียของท่านอย่างน้อยหนึ่งบัญชีเพื่อยืนยันความถูกต้องว่าเป็นของท่าน",
  mediaUploadText: "อัปโหลดภาพถ่ายหน้าจอแดชบอร์ดจากช่องของท่าน",
  createTypeTitle: "2. ท่านสร้างคอนเทนต์ประเภทไหน?",
  createTypeDesc: "เลือกอย่างน้อย 1 อย่างจากต่อไปนี้",
  mainGameTitle: "3. เลือกเกมหลักของท่าน",
  mainGameDesc: [
    "โปรดเลือกหนึ่งในเกมต่อไปนี้ที่ท่านเคยสร้างคอนเทนต์",
    "ท่านยังสามารถเพิ่มหรือปรับเปลี่ยนเกมที่เลือกหลังจากเป็นสมาชิกของ Creator Zone แล้วได้"
  ],
  uidPlace: "UID ของท่าน (ตัวเลขเท่านั้น)",
  userNamePlace: "ชื่อผู้ใช้ของท่าน",
  verifiCodPlace: "รหัสยืนยัน",
  userDetailTitle: "ช่วยให้เรารู้จักท่านดียิ่งขึ้น",
  userDetailSubTitle1: "ใส่วันเกิดของท่าน",
  userDetailSubDesc1: "*ข้อมูลนี้จะไม่สามารถปรับเปลี่ยนได้หลังจากที่ใบสมัครของท่านได้รับอนุมัติแล้ว",
  day: "วัน",
  month: "เดือน",
  year: "ปี",
  userDetailSubTitle2: "โปรดกรอกชื่อจริงของท่าน",
  firstName: "ชื่อ",
  laseName: "นามสกุล",
  userDetailSubTitle3: "ภาษา",
  userDetailSubTitle4: "ประเทศหรือภูมิภาค",
  userDetailSubTitle5: "ประเทศหรือภูมิภาค",
  discordTitle: "Discord ID ของท่าน",
  discordDesc: "สำหรับให้เราติดต่อและสื่อสารกับท่าน",
  submitBtn: "ส่ง",
  confirm: "ยืนยัน",

  // fl84
  mainGameFl84Title: "3. ENTER YOUR IN-GAME UID FOR VERIFICATION",
  mainGameFl84Desc: [
    "Please enter your Farlight 84 in-game UID for verification. ",
    "The Verification Code will be sent to you via mail in the game. ",
    "Note: Once UID is registered, it can't be changed."
  ],
  mediaUploadVideoTitle: "Please upload 1 video related to <strong>Farlight 84</strong> on this channel.<br />Submissions that don&apos;t meet the requirements will not be approved.",
  mediaUploadVideoDesc: "(Note: The submitted video title must include the keyword &quot;<strong>Farlight 84</strong>&quot;, and description should contain #Farlight84 and #Farlight84fcc.)",
  mediaUploadPlace: "Insert content URL here",
  sendCode: "Send Verification Code",
  whatIsUID: "What is UID and Verification Code?",
  Verified: "UID Verified",
  submitCodeTip: "The verification code has been sent to your in-game mailbox. Please check and return to this page to enter it."
};

// 管理内页-导航
const adminNavData = {
  home: "หน้าแรก",
  gameFeed: "ข่าวสารเกม",
  artAssets: "แอสเซ็ตงานศิลป์",
  myContent: "คอนเทนต์ของฉัน",
  uploadContent: "อัปโหลดคอนเทนต์",
  manageContent: "จัดการคอนเทนต์",
  viewEarnings: "ดูรายได้",

  // m
  growth: "การเติบโตและการพัฒนา",
};

// 管理内页-首页
const adminHomeData = {
  // 数据总浏
  overview: {
    title: "ภาพรวมคอนเทนต์",
    navItem1: "ภาพรวมข้อมูล",
    navItem2: "ภาพรวมคอนเทนต์ประจำเดือน",
    totalCount: "ยอดคอนเทนต์",
    totalView: "ยอดรับชม",
    totalLike: "ยอดถูกใจ",
    totalComments: "ยอดความคิดเห็น"
  },
  // 推送
  message: {
    more: "อื่นๆ"
  },
  // 收益
  earning: {
    title: "รายได้ของฉัน",
    item1Name: "เดือน",
    item2Name: "รางวัลในเกม",
    item3Name: "เงินสด",

    settionLoad: "อยู่ในระหว่างการดำเนินการ"
  },
  userDetail: {
    welcome: "ยินดีต้อนรับกลับมา ",
    timeText: "ท่านเป็นสมาชิกบนแพลตฟอร์มนี้มาเป็นเวลา ",
    timeUnit1: "วันแล้ว",
    timeUnit2: "วันแล้ว",
  }
};

// 管理内页-素材推送
const artAssetsData = {
  artAssetsTitle: "แอสเซ็ตงานศิลป์",
  selectPlace: "เลือกโดยชื่อ/คีย์เวิร์ด",
  googleLinkBtn: "ลิงก์ google drive",
  request: "คำขอสำหรับดาวน์โหลด",
  download: "downloading",
  requested: "ร้องขอแล้ว",
  noTip: "ไม่มีข้อมูล"
};

// 管理内页-游戏资讯
const gameFeedData = {
  gameFeedTitle: "ข่าวสารเกม",
  selectPlace: "เลือกโดยชื่อ/คีย์เวิร์ด",
  noTip: "ไม่มีข้อมูล",
};

// 管理内页-收益
const earningData = {
  earningTitle: "ดูรายได้",
  subTitle: "รายได้รายเดือน",
  item1Name: "เดือน",
  item2Name: "รางวัลในเกม",
  item3Name: "เงินสด",
  rewards: "คำอธิบายรางวัล",

  detailTitle1: "คำอธิบายรางวัล",
  detailSubTitle1: "รายการวิดีโอของท่าน",
  detailTimeTitle: "ช่วงเวลาตามข้อตกลง:",
  detailDesc: "นับเฉพาะวิดีโอที่เผยแพร่ในระหว่างช่วงเวลานี้เท่านั้น",
  noData: "ไม่มีข้อมูล",
  detailRewards: "รางวัลเพชรช่วงเวลา : เพชร",
  detailRewardsUnit: "เม็ด",
  detailRewardsDescTitle: "วันตามข้อตกลง:",
  detailRewardsDesc1_1: "ข้อมูลยอดรับชมจะขึ้นอยู่กับข้อมูลที่แพลตฟอร์มโซเชียลมีเดียบันทึกไว้ในวันตามข้อตกลง ถ้าท่านมีข้อสงสัยเกี่ยวกับรายละเอียดรางวัลนี้ โปรดติดต่อกัปตัน / ฝ่ายบริการลูกค้าบน Discord",
  detailRewardsDesc1_2: " ",
  detailRewardsDesc1_3: " ",
  detailUnit1: "ชื่อคอนเทนต์",
  detailUnit2: "จำนวนรับชม",
  detailUnit3: "วันเผยแพร่",
  detailUnit4: "ช่อง",
};

// 管理内页-上传
const upLoadContentData = {
  uploadTitle1: "อัปโหลดคอนเทนต์",
  upLoadPlace1: "แทรก URL ของคอนเทนต์ที่นี่",
  submitBtn: ["ยืนยัน", "อัปโหลดคอนเทนต์", "SUBMIT"],
  time: "ประทับเวลา",
  rightNow: "ตอนนี้",
  itemTitle1: "ยอดชมรวม",
  itemTitle2: "ยอดถูกใจ",
  itemTitle3: "ยอดความคิดเห็น",
  step1: "ขั้นตอนที่ 1: <span>เลือกงานครีเอเตอร์หรือการอัปโหลดธรรมดา?</span>",
  step2: "ขั้นตอนที่ 2: <span>อัปโหลดคอนเทนต์</span>",
  taskDetail: "รายละเอียดเพิ่มเติม",
  taskTitle: ["ธีม", "เวลา", "รางวัล"],
  normalUpload: "การอัปโหลดคอนเทนต์ธรรมดา",
  taskEvent: "อีเวนต์การส่งปัจจุบัน:",
  addUrl: "เพิ่ม URL ของคอนเทนต์",
};

// 管理内页-视频管理
const uploadManageData = {
  title: "จัดการคอนเทนต์ของฉัน",
  selectPlace: "เลือกโดยชื่อ/คีย์เวิร์ด",
  eventPlace: "อีเวนต์การส่งวิดีโอ",
  totalCount: "ยอดคอนเทนต์",
  totalView: "ยอดรับชม",
  totalLike: "ยอดถูกใจ",
  totalComments: "ยอดความคิดเห็น",
  delete: "ลบ",
  sTime: "วันที่เริ่ม",
  eTime: "วันที่สิ้นสุด"
};

// 注册协议弹窗
const communityTip = [
  "1. เคารพ",
  "เราต้องการสร้างสภาพแวดล้อมที่ให้การต้อนรับสำหรับทุกคน เสรีภาพในการแสดงออกคือสิ่งมีคุณค่าอย่างสูง แต่ภาษาก้าวร้าวหรือพฤติกรรมร้ายทางอ้อมสามารถนำไปสู่คำเตือนไปจนถึงการแบนจาก Creator Zone ในท้ายที่สุดได้",
  "2. การเลือกปฏิบัติ",
  "ไม่อนุญาตให้มีการกลั่นแกล้งหรือพฤติกรรมการเลือกปฏิบัติใดๆ ความคิดเห็นที่เป็นการด้อยค่าเกี่ยวกับชาติพันธุ์ ศาสนา วัฒนธรรม ความหลากหลายทางเพศ เพศสภาพหรืออัตลักษณ์ จะไม่ได้รับการยินยอมให้เกิดขึ้น และอาจเป็นผลให้ถูกแบนจาก Creator Zone",
  "3. การขายบัญชี",
  "การขายบัญชี บริการการแลกเปลี่ยนหรือส่งเสริม (ชำระเงิน) เป็นสิ่งต้องห้าม ครีเอเตอร์คนใดก็ตามที่เกี่ยวข้องกับกิจกรรมประเภทเหล่านี้อาจเป็นผลให้ถูกแบนจาก Creator Zone",
  "4. เนื้อหาลามกอนาจารหรือรบกวนจิตใจ",
  "การแจกจ่ายเนื้อหาลามกอนาจารหรือรบกวนจิตใจอาจเป็นผลให้ถูกแบนจาก Creator Zone",
  "5. การคัดลอกผลงาน",
  "คอนเทนต์ที่ถูกสร้างทั้งหมดควรเป็นผลงานต้นฉบับ การคัดลอกผลงานอาจส่งผลให้ถูกแบนจาก Creator Zone",
  "6. การตัดสินของทีมงานถือเป็นสิ้นสุด",
  "ทาง Lilith Games และ Farlight Games ขอสงวนสิทธิ์ในการตัดสินและตีความกฎเหล่านี้ และคำตัดสินดังกล่าวถือเป็นสิ้นสุด นอกจากนี้ยังอาจหมายรวมถึงประเด็นอื่นๆ ที่ถึงแม้จะไม่ได้ถูกระบุไม่อย่างชัดเจน แต่อาจนำมาซึ่งปัญหา ทางทีมงานขอสงวนสิทธิ์ในการตีความมูลเหตุเหล่านั้นด้วย",
];

// 弹窗文案
const dialogText = {
  login: "ล็อกอิน",
  enterYourEmail: "ใส่อีเมลของท่าน",
  enterYourPassword: "ใส่รหัสผ่านของท่าน",
  password: "รหัสผ่าน",
  forgotPassword: "ลืมรหัสผ่าน?",
  emailQuickLogin: "ล็อกอินด่วนอีเมล",
  signTip: "ไม่มีบัญชี?",
  signIn: "สมัคร",
  codeTip: "ใส่รหัสตัวเลข 6 หลัก",
  send: "ส่งรหัส",
  set: "ตั้งรหัสผ่านใหม่",
  next: "ถัดไป",
  setNew: "โปรดตั้งรหัสผ่านใหม่",
  confirmPassword: "ยืนยันรหัสผ่าน",
  confirm: "ยืนยัน",
  allowAuthorize: "ไม่ว่าจะอนุญาตให้ดึงข้อมูลหรือไม่",
  allow: "อนุญาต",
  refuse: "ปฏิเสธ",
  applicationText1: "ส่งใบสมัครของท่านแล้ว",
  applicationText2: "ท่านจะได้รับอีเมลตอบกลับภายใน 5 วันทำการ",
  verify: "ยืนยันรหัสผ่านปัจจุบัน",
  signAgreement: "เซ็นข้อตกลง",
  upLoadTip: "อัปโหลดภาพถ่ายหน้าจอแดชบอร์ดจากช่องของท่าน",
  save: "บันทึก",
  setNewName: "ตั้งชื่อผู้ใช้ใหม่",
  setNameNeed: "สามารถเปลี่ยนชื่อได้หนึ่งครั้งทุกสามเดือน",
  userNameSet: "ตั้งชื่อผู้ใช้",
  userNameVerify: "โปรดตั้งอักขระ 2-24 ตัว",
  gameTag: "แท็กเกม"
};

// IGame首页文案
const iGameHomeData = {
  enterYourEmail: "ใส่อีเมลของท่าน ",
  password: "รหัสผ่าน",
  forgotPassword: "ลืมรหัสผ่าน?",
  emailLogin: "ล็อกอินด่วนอีเมล",
  pwdLogin: "กลับไปใช้รหัสผ่าน",
  signUp1: "ไม่มีบัญชี? ",
  signUp2: "สมัคร",
  send: "ส่งรหัส",
  codeTip: "ใส่รหัสตัวเลข 6 หลัก",
  desc1: "หนทางเดียวในการร่วมมือกับเราอย่างเป็นทางการเพื่อรับสิทธิ์แอบส่องแบบเอ็กซ์คลูซีฟ เครื่องมือต่างๆ และการสนับสนุนเพื่อสร้างคอนเทนต์ที่ดีที่สุด!",
  desc2_1: "รับผลประโยชน์เอ็กซ์คลูซีฟ เราจะมอบเครื่องมือที่จำเป็นเพื่อนำพาการสร้างคอนเทนต์ของท่านให้ก้าวขึ้นไปอีกระดับ!",
  desc2_2: "ติดต่อกับพนักงานของเราเพื่อขอการสนับสนุนและเคล็ดลับ เราจะมอบความช่วยเหลือเพื่อทำให้ช่องของท่านเติบโดยการเผยแพร่เนื้อหาของท่านบนแพลตฟอร์มของเรา!",
  desc2_3: "เป็นส่วนหนึ่งของ Creators Discord ที่เชื่อถือได้ของเรา ที่ท่านสามารถเชื่อมต่อกับคอนเทนต์ครีเอเตอร์จากทั่วโลก!",
  tier1_1: "คำเชิญสู่เซิร์ฟเวอร์ Discord ของวิดีโอคอนเทนต์ครีเอเตอร์เอ็กซ์คลูซีฟของเรา",
  tier1_2: "ระบบตั๋วเอ็กซ์คลูซีฟบนเซิร์ฟเวอร์ Discord ของครีเอเตอร์เพื่อรับความช่วยเหลือจากพนักงานแบบ 1 ต่อ 1",
  tier1_3: "เข้าถึงแอสเซ็ตงานศิลป์ทางการเพื่อช่วยเหลือท่านในการสร้างคอนเทนต์",
  tier1_4: "มีโอกาสที่จะได้รับรางวัลในเกมและ/หรือการชดเชยด้วยเงิน",
  tier2_1: "ผลประโยชน์ทั้งหมดในระดับฝึกหัด",
  tier2_2: "มีโอกาสที่คอนเทนต์ของท่านจะถูกนำเสนอบนแพลตฟอร์มโซเชียลมีเดียทางการของเรา",
  tier3_1: "ผลประโยชน์ทั้งหมดในระดับก่อนหน้านี้",
  tier3_2: "รหัสของขวัญกำหนดเองสำหรับให้ท่านแจกแก่ผู้ชม",
  tier3_3: "มีโอกาสได้รับเชิญเข้าสู่อีเวนต์ AFK Journey ทางการ",
  tier3_4: "มีโอกาสร่วมสร้างคอนเทนต์กับทีมงาน AFK Journey",
  updateText: "อัปเดตล่าสุดวันที่"
};

// 提交申请表单成功
const signTip = "ยินดีด้วย! ใบสมัครสำหรับ Creator Zone ของท่านได้รับอนุมัติแล้ว โปรดเซ็นชื่อในข้อตกลงครีเอเตอร์ที่ส่งให้ท่านทางอีเมลก่อนที่ท่านจะได้รับสิทธิ์เข้าถึงแพลตฟอร์มของเราอย่างครบถ้วน";

export default {
  topNavData,
  footerData,
  homeData,
  signUpLanguageData,
  signData,
  informationData,
  guideData,
  applicationData,
  adminNavData,
  adminHomeData,
  artAssetsData,
  gameFeedData,
  earningData,
  upLoadContentData,
  uploadManageData,
  signTip,
  communityTip,
  dialogText,
  iGameHomeData,
};